import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const ADMIN_TOKEN_KEY = "fss_admin_token";
export function getAdminToken() { return localStorage.getItem(ADMIN_TOKEN_KEY) || ""; }
export function setAdminToken(token) {
  if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
  else localStorage.removeItem(ADMIN_TOKEN_KEY);
}
export const adminApi = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});
adminApi.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Four-division service list for enquiry form.
export const SERVICES = [
  // Fire Safety
  "Fire Alarm System",
  "Emergency Lighting",
  "Fire Extinguishers",
  "Testing & Certification",
  "Planned Maintenance",
  "Fault or Repair",
  "System Upgrade",
  // CCTV & Security
  "CCTV Installation",
  "CCTV Upgrade",
  "Remote Viewing",
  "Video Analytics",
  "Intruder Alarm",
  "Perimeter Security",
  "Personal Alarm",
  "Security System Maintenance",
  // Access Control
  "Door Access Control",
  "Card or Fob Access",
  "Keypad Entry",
  "Biometric Access",
  "Intercom System",
  "Gate or Barrier Access",
  "Visitor Entry",
  "Access Control Maintenance",
  // Monitoring
  "Alarm Monitoring",
  "CCTV Monitoring",
  "Remote CCTV Verification",
  "Panic Alarm",
  "Lone Worker Protection",
  "Vulnerable Person Alarm",
  "Multi-Site Monitoring",
  "Monitoring Support",
  // Cross
  "Multi-Site Services",
  "General Enquiry",
  "Request a Quote",
];
